import { render, staticRenderFns } from "./BodyParts.vue?vue&type=template&id=11314658&"
import script from "./BodyParts.vue?vue&type=script&lang=js&"
export * from "./BodyParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports